import { FORTA_GRAY9 } from '../../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';

export const NO_MEDICATION_LABEL_SX: SxProps<Theme> = {
  fontFamily: 'DMSansBold',
  fontSize: 15,
  color: FORTA_GRAY9,
};
